import React from 'react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../routes';
import BannerPcWebDesigner from './images/banner_pc_webdesigner.png';
import BannerPcWriter from './images/banner_pc_writer.png';
import BannerPcMarketer from './images/banner_pc_marketer.png';
import BannerPcPopular from './images/banner_pc_popular.png';
import BannerSpWebDesigner from './images/banner_sp_webdesigner.png';
import BannerSpWriter from './images/banner_sp_writer.png';
import BannerSpMarketer from './images/banner_sp_marketer.png';
import BannerSpPopular from './images/banner_sp_popular.png';
import SheFukidashi from './images/she_fukidashi.png';
import './coursePackLink.module.scss';
import ArrowDown from './images/arrow-down.svg';
import ArrowUp from './images/arrow-up.svg';
import { CourseListPageState } from './states/CourseListPageState';
import { observer } from 'mobx-react';
import classNames from 'classnames';

type Props = {
  state: CourseListPageState;
};

const ToggleHeader = ({ showCourseSetList }: { showCourseSetList: boolean }) => {
  return (
    <>
      {showCourseSetList ? (
        <>
          <p styleName="title">おすすめセットを閉じる</p>
          <img src={ArrowUp} styleName="icon-arrow" />
        </>
      ) : (
        <>
          <p styleName="title">おすすめセットを見る</p>
          <img src={ArrowDown} styleName="icon-arrow" />
        </>
      )}
    </>
  );
};

export const CoursePackLink = observer(({ state }: Props) => {
  return (
    <div styleName="wrapper">
      {GlobalStatesV3.viewport.isMobile && <img src={SheFukidashi} styleName="she-image" />}
      <div
        styleName={classNames('section', state.showCourseSetList ? 'section-open' : 'section-close')}
        onClick={() => state.toggleShowCourseSetList()}
      >
        {GlobalStatesV3.viewport.isDesktop && <img src={SheFukidashi} styleName="she-image" />}
        <ToggleHeader showCourseSetList={state.showCourseSetList} />
      </div>
      {state.showCourseSetList && (
        <div styleName="link-wrapper">
          <div styleName="set-links">
            {GlobalStatesV3.viewport.isNonSp && (
              <>
                <Link to={V3Routes.courseSet('web-designer')} styleName="set-link">
                  <img src={BannerPcWebDesigner} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('writer')} styleName="set-link">
                  <img src={BannerPcWriter} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('marketer')} styleName="set-link">
                  <img src={BannerPcMarketer} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('popular')} styleName="set-link">
                  <img src={BannerPcPopular} styleName="set-img" />
                </Link>
              </>
            )}
            {GlobalStatesV3.viewport.isSp && (
              <>
                <Link to={V3Routes.courseSet('web-designer')} styleName="set-link">
                  <img src={BannerSpWebDesigner} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('writer')} styleName="set-link">
                  <img src={BannerSpWriter} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('marketer')} styleName="set-link">
                  <img src={BannerSpMarketer} styleName="set-img" />
                </Link>
                <Link to={V3Routes.courseSet('popular')} styleName="set-link">
                  <img src={BannerSpPopular} styleName="set-img" />
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
});
